/*
 * @Author: LILy0401 2686739469@qq.com
 * @Date: 2024-07-18 10:12:44
 * @LastEditors: LILy0401 2686739469@qq.com
 * @LastEditTime: 2024-07-31 14:41:06
 * @FilePath: \eiiplat_front\src\api\application.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import request from "@/utils/request";

export function getClassifyTree() {
  return request({
    // http://47.96.70.127:88/api/app-community/ac-classify/getClassifyTree
    url: "/app-community/ac-classify/getClassifyTree",
    method: "get"
  })
}
// 应用分类列表
export function listDemand(params) {
  return request({
    url: "/app-community/co-demand/listDemand",
    method: "get",
    params
  })
}
// 查询应用详情
export function getDemandForFront(params) {
  return request({
    url: "/app-community/co-demand/getDemandForFront",
    method: "get",
    params
  })
}
export function getDetailNew(params) {
  return request({
    url: '/app-community/co-demand/getDetailNew',
    method: 'post',
    params
  })
}
// 生成订单
export function addOrder(data) {
  return request({
    url: '/app-community/demandOrder/addOrder',
    method: 'post',
    data
  })
}
export function getDemandOrderById(params) {
  return request({
    url: "/app-community/demandOrder/getDemandOrderById",
    method: "get",
    params
  })
}

export function demandOrderpay(data) {
  return request({
    url: "/app-community/demandOrder/pay",
    method: "post",
    data
  })
}
// 0元试用
export function addTrial(data) {
  return request({
    url: "/app-community/demandTrial/addTrial",
    method: "post",
    data
  })
}

export function getTrialInfo(params) {
  return request({
    url: "/app-community/demandTrial/getTrialInfo",
    method: "get",
    params
  })
}


// WEBPACK FOOTER //
// ./src/api/application.js